import { render } from "./HomeTab.vue?vue&type=template&id=48f10662&ts=true"
import script from "./HomeTab.vue?vue&type=script&lang=ts"
export * from "./HomeTab.vue?vue&type=script&lang=ts"

import "./HomeTab.vue?vue&type=style&index=0&id=48f10662&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__